import "./CoverSection.css";
import { Link } from "react-scroll";
import { motion } from "framer-motion";
import RLDLogo from "../../images/Cover/Logo_Basic_green.png";
import heroPoster from "../../images/Cover/hero-cover.webp";

// Drop your reel path here when ready, e.g. "/videos/reel.mp4"
const HERO_VIDEO_SRC = null;

function CoverSection() {
  return (
    <section className="snap-section relative flex min-h-screen items-center justify-center overflow-hidden bg-rld-black">
      <div className="absolute inset-0">
        {HERO_VIDEO_SRC ? (
          <video
            className="h-full w-full object-cover grayscale contrast-110"
            autoPlay
            muted
            loop
            playsInline
            poster={heroPoster}
          >
            <source src={HERO_VIDEO_SRC} type="video/mp4" />
          </video>
        ) : (
          <div
            className="h-full w-full scale-105 bg-cover bg-center grayscale contrast-110"
            style={{ backgroundImage: `url(${heroPoster})` }}
          />
        )}

        <div className="absolute inset-0 bg-gradient-to-b from-rld-black/80 via-rld-black/60 to-rld-black" />
        <div className="hero-grid absolute inset-0" />
        <div className="hero-scanline absolute inset-0" />
      </div>

      <div className="relative z-10 flex min-h-screen w-full flex-col items-center justify-center px-6 pt-20 pb-16 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="flex flex-col items-center"
        >
          <img
            src={RLDLogo}
            alt="Rare Life Design"
            className="mb-8 w-4/5 max-w-md brightness-0 invert md:max-w-xl lg:max-w-2xl"
          />

          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-rld-white/40" />
            <p className="font-mono text-xs uppercase tracking-widest text-rld-muted md:text-sm">
              Production Design & Programming
            </p>
            <span className="h-px w-8 bg-rld-white/40" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.7 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
        >
          <Link
            to="services"
            spy={true}
            smooth={true}
            offset={-64}
            duration={500}
            className="group flex flex-col items-center gap-2"
            aria-label="Scroll to services"
          >
            <span className="font-mono text-[10px] uppercase tracking-widest text-rld-dim transition-colors group-hover:text-rld-white">
              Explore
            </span>
            <svg
              className="h-4 w-4 animate-scroll-pulse text-rld-dim transition-colors group-hover:text-rld-white md:hidden"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
            <div className="hidden h-10 w-6 items-start justify-center rounded-full border border-rld-border p-1.5 transition-colors group-hover:border-rld-white/50 md:flex">
              <div className="h-2 w-px animate-scroll-pulse bg-rld-white" />
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}

export default CoverSection;
